import { useEffect, useState } from "react";

/**
 * Returns a value that updates only after `delay` ms of inactivity.
 * Useful for debouncing search query params without delaying the input UI.
 */
export function useDebouncedValue(value, delay = 500) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    if (value === debouncedValue) return;

    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(timer);
  }, [value, delay, debouncedValue]);

  return debouncedValue;
}
